import React, { useContext, useEffect, useState } from 'react';
import { Alert, Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormFeedback, Input, Label, ListGroup, ListGroupItem, Row, Spinner, Table, UncontrolledAlert } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { toast } from 'react-toastify';
import { clearVehicleInspection, getPendingVehicleInspection } from '../../../Actions/InspectionActs';
import AddInspection from './AddInspection';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const InspectionStage = ()=>{
    const navigate = useNavigate();
    const [formVehicleValid, setFormVehicleValid] = useState(false);
    const [formVehicle,setFormVehicle] = useState({plate_number:'',});
    const [formVehicleErrors,setFormVehicleErrors] = useState({
        plate_number:'Plate number is required',
    });
    const [vehicleData,setVehicleData] = useState({});
    const [vehicleInsuranceData,setVehicleInsuranceData] = useState({});

    const {InspectionDispatch,InspectionState:{
        fetchVehiclePendingInspection:{error,loading,data},
    }} = useContext(GlobalStore);

    useEffect(() => {
        const isValid = Object.values(formVehicleErrors).every(item => !item);
        setFormVehicleValid(isValid);
    }, [formVehicleErrors]);

    const onChangeVehicle = ({name,value}) => {
        if(name === 'plate_number') value = value.toUpperCase();
        setFormVehicle((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormVehicleErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormVehicleErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }


    const onSubmitPlateNumber = async (e) => {
        e.preventDefault();
    
        if (formVehicleValid) {
            try {
                const response = await getPendingVehicleInspection(formVehicle)(InspectionDispatch);
                
                if (response.status) {
                    if (response?.has_active_route) {
                        const { inspection_master_id,route_from,route_to,vehicle } = response.data;
                        setVehicleData(vehicle);
    
                        /*Swal.fire({
                            title: `${route_from} - ${route_to}`,
                            text: response.message,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, proceed!'
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                // Logic to handle the confirmed action, e.g., navigating to a different page
                                // window.location.href = `/vehicle-inspection/form?inspection_master_id=${inspection_master_id}`;
                            }
                        });*/

                    } else {
                        const { vehicle, insurance } = response.data;
                        setVehicleData(vehicle);
                        // setVehicleInsuranceData(insurance?.CoverNoteDtl);
                    }
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.error || 'An error occurred: ' + error.message);
            }
        }
    };

    const NewInspection = ()=>{
        setFormVehicle({plate_number:'',})
        setFormVehicleErrors({plate_number:'Plate number is required',})
        clearVehicleInspection(InspectionDispatch)
    }

    return(
        <React.Fragment>
            <Row className="mt-5">
                <Col md="4">

                    <Card className='shadow-sm'>
                        <CardHeader>Vehicle Details</CardHeader>
                        <CardBody>

                            {Object.keys(vehicleData).length > 0? (

                                <Table>
                                    <tr>
                                        <th>Owner:</th>
                                        <td className='text-end text-muted'>{vehicleData?.owner}</td>
                                    </tr>
                                    <tr>
                                        <th>RegNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.regno}</td>
                                    </tr>
                                    <tr>
                                        <th>Tin:</th>
                                        <td className='text-end text-muted'>{vehicleData?.tin}</td>
                                    </tr>
                                    <tr>
                                        <th>Address:</th>
                                        <td className='text-end text-muted'>{vehicleData?.address}</td>
                                    </tr>
                                    <tr>
                                        <th>Vehicle:</th>
                                        <td className='text-end text-muted'>{vehicleData?.vehicle}</td>
                                    </tr>
                                    <tr>
                                        <th>EngineNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.engineno}</td>
                                    </tr>
                                    <tr>
                                        <th>ChassisNo:</th>
                                        <td className='text-end text-muted'>{vehicleData?.chassisno}</td>
                                    </tr>
                                    <tr>
                                        <th>Desc:</th>
                                        <td className='text-end text-muted'>{vehicleData?.titledesc}</td>
                                    </tr>
                                    <tr>
                                        <th>Mobile:</th>
                                        <td className='text-end text-muted'>{vehicleData?.mobile}</td>
                                    </tr>
                                    <tr>
                                        <th>Driver:</th>
                                        <td className='text-end text-muted'>{vehicleData?.tdriver}</td>
                                    </tr>
                                </Table>

                            ):(
                                <React.Fragment>
                                    {loading && (
                                        <div className='d-flex justify-content-center'>
                                            <Spinner size="sm"/>
                                        </div>
                                    )}
                                    {!loading && <small className='text-danger text-center'>* No details to display, Enter plate number to see details</small>}
                                </React.Fragment>
                            )}
                            
                        </CardBody>
                    </Card>

                    <Card className='shadow-sm'>
                        <CardHeader>Vehicle Insurance Details</CardHeader>
                        <CardBody>

                            {Object.keys(vehicleInsuranceData).length > 0? (

                                <ListGroup>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Type Desc:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteTypeDesc}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Number:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteNumber}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Reference Number:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteReferenceNumber}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Insurer Company Code:</strong></div>
                                        <small>{vehicleInsuranceData?.InsurerCompanyCode}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Insurer Company Name:</strong></div>
                                        <small>{vehicleInsuranceData?.InsurerCompanyName}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Issue Date:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteIssueDate}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Start Date:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteStartDate}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note End Date:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteEndDate}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Cover Note Desc:</strong></div>
                                        <small>{vehicleInsuranceData?.CoverNoteDesc}</small>
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <div><strong>Operative Clause:</strong></div>
                                        <small>{vehicleInsuranceData?.OperativeClause}</small>
                                    </ListGroupItem>
                                </ListGroup>

                            ):(
                                <React.Fragment>
                                    {loading && (
                                        <div className='d-flex justify-content-center'>
                                            <Spinner size="sm"/>
                                        </div>
                                    )}
                                    {!loading && <small className='text-danger text-center'>* No details to display, Enter plate number to see details</small>}
                                </React.Fragment>
                            )}
                            
                        </CardBody>
                    </Card>
                    
                </Col>
                <Col md="8">
                    <Card className="shadow-sm card-animate">
                        <CardHeader tag="div">
                            <span className="ri-truck-line"></span>
                            <span className="ms-1">VEHICLE INSPECTION</span>
                        </CardHeader>
                            {Object.keys(vehicleData).length === 0? (
                                <Form onSubmit={onSubmitPlateNumber}>
                                    <React.Fragment>
                                        <CardBody>
                                            {data?.has_active_route && (
                                                <UncontrolledAlert color='warning' className="alert-additional mb-0">
                                                    <div className="alert-body">
                                                        <div className="d-flex">
                                                            <div className="flex-shrink-0 me-3">
                                                                <i className="ri-alert-line fs-16 align-middle"></i>
                                                            </div>
                                                            <div className="flex-grow-1">
                                                            <h5 className="alert-heading">Active route</h5>
                                                                <p className="mb-0">{`${data?.data?.route_from} - ${data?.data?.route_to}`}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="alert-content">
                                                        <p className="mb-0">{data?.message}, click proceed to add new checkpoint</p>
                                                    </div>
                                                </UncontrolledAlert>
                                            )}

                                            {!data?.has_active_route && (<Row>
                                                <Col>
                                                    <Label>Enter plate number</Label>
                                                    <Input 
                                                        type='text' 
                                                        placeholder='Enter vehicle No. e.g T133ABC'
                                                        value={formVehicle?.plate_number}
                                                        onChange={(e) => onChangeVehicle({name:'plate_number',value:e.target.value})}
                                                        valid={formVehicleErrors.plate_number === ''}
                                                        invalid={formVehicleErrors.plate_number !== ''}
                                                    />
                                                    {formVehicleErrors.plate_number && <FormFeedback>{formVehicleErrors.plate_number}</FormFeedback>}
                                                </Col>
                                            </Row>)}

                                        </CardBody>
                                        <CardFooter>
                                            <div className='d-flex justify-content-end'>

                                                {data?.has_active_route && (
                                                    <Button disabled={!data?.data?.inspection_master_id}>
                                                        <NavLink 
                                                            to="/vehicle-inspection/form" 
                                                            state={data?.data}
                                                            className="nav-link fs-13">
                                                            <span className="icon-ws menu-titlse">Yes, Proceed</span>
                                                        </NavLink>
                                                    </Button>
                                                )}
                                                
                                                {!data?.has_active_route && (<Button className='ms-1' disabled={!formVehicleValid} size='sm'>
                                                    {loading && <Spinner size="sm"/>}
                                                    <span className='ms-1'>Fetch data</span>
                                                </Button>)}

                                                {data?.has_active_route && (<Button 
                                                    className='ms-1' 
                                                    size='sm' onClick={(e)=>NewInspection()}>
                                                    <span className='ms-1'>New inspection</span>
                                                </Button>)}
                                            </div>
                                        </CardFooter>
                                    </React.Fragment>
                                </Form>
                            ):(
                                <React.Fragment>
                                    <AddInspection/>
                                </React.Fragment>
                            )}
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default InspectionStage;